/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Native_Release_Widget_Week_StreakInputs */

const en_us2_native_release_widget_week_streak = /** @type {(inputs: Native_Release_Widget_Week_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Streak: ${i?.weeks} weeks`)
};

const pt_br2_native_release_widget_week_streak = /** @type {(inputs: Native_Release_Widget_Week_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sequência: ${i?.weeks} semanas`)
};

const pt_pt2_native_release_widget_week_streak = /** @type {(inputs: Native_Release_Widget_Week_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sequência: ${i?.weeks} semanas`)
};

/** @type {(inputs: Native_Release_Widget_Week_StreakInputs) => LocalizedString} */
const es_419_native_release_widget_week_streak = en_us2_native_release_widget_week_streak;

/** @type {(inputs: Native_Release_Widget_Week_StreakInputs) => LocalizedString} */
const fr_fr2_native_release_widget_week_streak = en_us2_native_release_widget_week_streak;

/** @type {(inputs: Native_Release_Widget_Week_StreakInputs) => LocalizedString} */
const de_de2_native_release_widget_week_streak = en_us2_native_release_widget_week_streak;

/** @type {(inputs: Native_Release_Widget_Week_StreakInputs) => LocalizedString} */
const it_it2_native_release_widget_week_streak = en_us2_native_release_widget_week_streak;

/**
* | output |
* | --- |
* | "Streak: {weeks} weeks" |
*
* @param {Native_Release_Widget_Week_StreakInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_week_streak = /** @type {((inputs: Native_Release_Widget_Week_StreakInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Week_StreakInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_week_streak(inputs)
	if (locale === "es-419") return es_419_native_release_widget_week_streak(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_week_streak(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_week_streak(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_week_streak(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_week_streak(inputs)
	return en_us2_native_release_widget_week_streak(inputs)
});
export { native_release_widget_week_streak as "native-release.widget_week_streak" }